/*
 * trim: getLocalStorage
 * desc:
 * input: (string)
 * output: (value) or (false)
 */

const getLocalStorage = function (key) {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return false;
  }
};
export default getLocalStorage;
